// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Wkeh","buttons":"RemoveExpirationActionButtons_buttons__1Gl5-"};